import React from 'react'
import PropTypes from 'prop-types'
import SharePageViaEmail from 'components/common/SharePageViaEmail'

const BOTShareViaEmailForm = ({ title, emailTitle, emailDescription, requestPayload }) =>
  <SharePageViaEmail
    data-printless
    title={ title }
    modalProps={{ title: emailTitle, description: emailDescription, requestPayload }} />

BOTShareViaEmailForm.propTypes = {
  emailDescription: PropTypes.string,
  emailTitle: PropTypes.string,
  requestPayload: PropTypes.shape(),
  title: PropTypes.string
}

export default BOTShareViaEmailForm

